import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule, TooltipModule } from 'ngx-bootstrap';

import { FeedbackExecutionActionsModalComponent } from './feedback-execution-actions-modal/feedback-execution-actions-modal.component';
import { JobProfileModule } from 'src/app/pages/mission-control-page/job-profile-page/job-profile/job-profile.module';
import { JobMatchProfileOnConferenceModule } from 'src/app/pages/conference-page/conference/job-match-profile-on-conference/job-match-profile-on-conference.module';
import { FeedbackExecutionComponentModule } from './feedback-execution-component.module';
import { FeedbackExecutionComponent } from './feedback-execution.component';

@NgModule({
    declarations: [
        FeedbackExecutionActionsModalComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        JobProfileModule,
        JobMatchProfileOnConferenceModule,
        FeedbackExecutionComponentModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot()
    ],
    exports: [
        FeedbackExecutionActionsModalComponent,
        FeedbackExecutionComponent
    ],
    entryComponents: [
        FeedbackExecutionActionsModalComponent
    ]
})
export class FeedbackExecutionModule { }
